import { Location, NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BreadcrumbsComponent } from 'components/breadcrumbs/breadcrumbs.component';
import { BaseFormComponent } from 'components/form/base-form';
import { SearchClientInputComponent } from 'components/search-client-input/search-client-input.component';
import { ApiService } from 'services/api.service';
import { ToastService } from 'services/toast.service';
import { Breadcrumb } from 'types/breadcrumb.interface';
import { ClientCard } from 'types/client.interface';
import { getControlsWithErrors } from 'util/form.utility';
import { TooltipComponent } from "components/tooltip/tooltip.component";

export interface ServiceOption {
  url: string;
  name: string;
}

@Component({
  selector: 'app-create-service-application-page',
  standalone: true,
  imports: [BreadcrumbsComponent, TranslateModule, SearchClientInputComponent, ReactiveFormsModule, NgClass, TooltipComponent],
  templateUrl: './create-service-application-page.component.html',
  styleUrls: ['./create-service-application-page.component.scss', '../../components/form/base-form.scss']
})
export class CreateServiceApplicationPageComponent extends BaseFormComponent {
  breadcrumbs: Breadcrumb[] = [
    {
      title: 'components.breadcrumbs.workspace',
      url: '/lasitavas-apmeklejums'
    },
    {
      title: 'components.breadcrumbs.newServiceApplication',
      url: '/jauns-pakalpojuma-pieteikums'
    }
  ];
  services: ServiceOption[] = [
    {
      url: ':clientId/pakalpojumi/lasitavas-apmeklejums',
      name: 'visitReadingRoom'
    }
  ];
  selectedClient: ClientCard | null = null;

  constructor(
    protected override location: Location,
    protected override router: Router,
    protected override formBuilder: FormBuilder,
    protected override apiService: ApiService,
    protected override toastService: ToastService,
    protected override translateService: TranslateService
  ) {
    super(location, router, formBuilder, apiService, toastService, translateService);
  }

  fillForm() {
    this.form = this.formBuilder.group({
      serviceUrl: [this.services[0].url, [Validators.required]],
      clientId: [null, [Validators.required]]
    });
  }

  createApplication() {
    this.submitAttempted = true;

    if (this.form.valid) {
      this.submitAttempted = false;
      const serviceUrl = this.form.get('serviceUrl')?.value.replace(':clientId', this.form.get('clientId')?.value);

      this.router.navigate([serviceUrl]);
    } else {
      this.toastService.showFormValidationError(getControlsWithErrors(this.form), 'pages.createServiceApplication');
    }
  }

  onClientSelected(client: ClientCard | null): void {
    this.selectedClient = client ?? null;
    this.form.get('clientId')?.setValue(client?.id ?? null);
  }

  getFirstName(): string {
    if (!this.selectedClient?.fullName) {
      return '';
    }

    const parts = this.selectedClient.fullName.split(' ');
    if (parts.length <= 1) {
      return this.selectedClient.fullName;
    }

    return parts.slice(0, -1).join(' ');
  }

  getLastName(): string {
    const parts = this.selectedClient?.fullName?.split(' ');

    return parts ? parts[parts.length - 1] : '';
  }

  getAuthenticationTypeName(name: string | undefined) {
    switch (name) {
      case 'Local':
        return 'Izveidojis LNA darbinieks';
      case 'NationalId':
        return 'Latvija LV';
      case 'Email':
        return 'E-pasts';
      default:
        return name;
    }
  }
}
